import api from './api';

export const authApi = {
  register: async (data) => {
    return await api.post('/auth/register', data);
  },

  login: async (data) => {
    return await api.post('/auth/login', data);
  },

  logout: async () => {
    return await api.post('/auth/logout');
  },

  getMe: async () => {
    return await api.get('/auth/me');
  },
};
